export const CrownIcon = ({ className, onClick }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.99136 10.0156C2.99136 10.0156 4.4263 9.15823 6.99825 9.15823C9.5702 9.15823 11.0051 10.0156 11.0051 10.0156L12.9877 3.93986C13.0021 3.89858 13.0039 3.85392 12.9928 3.81163C12.9817 3.76933 12.9581 3.73133 12.9252 3.70252C12.8923 3.67371 12.8515 3.6554 12.8082 3.64995C12.7648 3.6445 12.7207 3.65216 12.6817 3.67194L9.81882 5.09938C9.76925 5.12387 9.71229 5.12888 9.65921 5.1134C9.60613 5.09792 9.56079 5.06309 9.53215 5.01579L7.18686 1.12089C7.16724 1.08874 7.13969 1.06217 7.10685 1.04374C7.07401 1.02531 7.03698 1.01562 6.99932 1.01562C6.96166 1.01562 6.92463 1.02531 6.89179 1.04374C6.85895 1.06217 6.8314 1.08874 6.81178 1.12089L4.46434 5.0174C4.43578 5.06493 4.39035 5.09994 4.33711 5.11543C4.28387 5.13093 4.22674 5.12577 4.17714 5.10098L1.31853 3.67462C1.27949 3.65496 1.23548 3.64739 1.19211 3.65287C1.14875 3.65836 1.10801 3.67665 1.0751 3.70542C1.0422 3.73418 1.01862 3.77211 1.00738 3.81435C0.996147 3.85659 0.997767 3.90122 1.01203 3.94253L2.99136 10.0156Z"
        stroke="#6A6A6A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
